import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/redux';
import { fetchProjectById, updateProject } from '../store/slices/projectsSlice';
import ProjectForm from '../components/Projects/ProjectForm';
import LoadingSpinner from '../components/UI/LoadingSpinner';

const EditProjectPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { items, isLoading } = useAppSelector((state) => state.projects);
  const { user } = useAppSelector((state) => state.auth);
  const project = id ? items[id] : null;

  useEffect(() => {
    if (id) {
      dispatch(fetchProjectById(id));
    }
  }, [dispatch, id]);

  const handleSubmit = async (data: any) => {
    if (!id) return;
    await dispatch(updateProject({ id, data }));
    navigate(`/projects/${id}`);
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <LoadingSpinner size="lg" text="Loading project..." />
      </div>
    );
  }

  if (!project) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-[var(--color-subtext-color)]">Project not found</p>
      </div>
    );
  }

  if (user?.id !== project.ownerId?._id) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-[var(--color-error-600)]">You don't have permission to edit this project</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Edit Project</h1>
      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        <div className="lg:col-span-2">
          <ProjectForm initialData={project} onSubmit={handleSubmit} />
        </div>
      </div>
    </div>
  );
};

export default EditProjectPage;

